import { IUser } from '../../core/services/users'

export interface IReward {
  id: string
  label: string
  tickets: string
  generateDate: Date
  createdBy: string
  sentTo: string
  used: boolean
  usedDate: Date
  email: string
  price: number
}

export const rewards: IReward[] = [
  {
    id: '424125',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    used: true,
    usedDate: new Date(),
    price: 100,
  },
  {
    id: '424126',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 1000,
    used: false,
    usedDate: new Date(),
  },
  {
    id: '424127',
    label: 'Endava',
    tickets: 'GA',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 900,
    used: false,
    usedDate: new Date(),
  },
  {
    id: '424128',
    label: 'Endava',
    tickets: 'GA',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 800,
    used: true,
    usedDate: new Date(),
  },
  {
    id: '424129',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 700,
    used: true,
    usedDate: new Date(),
  },
  {
    id: '424130',
    label: 'Endava',
    tickets: 'GA',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 10000,
    used: true,
    usedDate: new Date(),
  },
  {
    id: '424131',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 1000,
    used: false,
    usedDate: new Date(),
  },
  {
    id: '424132',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 1000,
    used: false,
    usedDate: new Date(),
  },
  {
    id: '424133',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 1000,
    used: false,
    usedDate: new Date(),
  },
  {
    id: '424134',
    label: 'Endava',
    tickets: '4 Days Access',
    generateDate: new Date(),
    createdBy: 'Adrian Bejenaru',
    sentTo: 'Sveatoslav Vizitiu',
    email: 'sveat@extasy.com',
    price: 1000,
    used: false,
    usedDate: new Date(),
  },
]

export interface IVoucherTickets {
  festivalEdition: {
    id: string
    name: string
  }
  ticket: {
    id: string
    name: string
  }
  category: {
    id: string
    name: string
  }
  dubaiOverwritePriceTypeCode?: string
}
export interface Vouchers {
  id: string
  label: string
  code: string
  exportPNG: boolean
  exportPDF: boolean
  exportSVG: boolean
  exportCSV?: boolean
  discountType: 'PERCENTAGE' | 'AMOUNT'
  amount: number
  type?: VoucherTypes
  contact?: Contact[]
  tickets: IVoucherTickets[]
  publishDate: number
  expiryDate: number
  createdBy: string
  totalUses: number | 'unlimited'
  published: boolean
  status: 'ACTIVE' | 'INACTIVE'
  userLimit?: number
  unlimited: boolean
  userUnlimited: boolean
  voucherLimit?: number
  usages?: number
  batchId?: string
}

export interface Invites {
  id: string
  price: number
  label: string
  used: boolean
  usedDateTimestamp: number
  user: InviteUser
  email: string
  ticket: InviteTicket
  generatedTimestamp: number
  redeemCode: string
  zipPassword: string
}

export interface InviteUser {
  id: string
  firstName: string
  lastName: string
  emailName: string
  phone: string
  label: string
}

export interface InviteTicket {
  festivalEdition: Name
  category: Name
  ticket: Name
}

interface Name {
  id: string
  name: string
}

export interface InviteDetails {
  id: string
  email: string
  ticket: InviteTicket
  price: number
  user: InviteUser
  used: boolean
  usedDateTimestamp: number
  label: string
  pdfLink: string
}

export interface DownloadVouchers {
  id: string
  pngEnabled: true
  svgEnabled: true
  pdfEnabled: true
  csvEnabled: true
  label: string
  nrOfVouchers: number
  status: 'PROCESSING' | 'COMPLETED' | 'FAILED'
  tickets: IVoucherTickets[]
}

export const invites: Invites[] = [
  {
    id: '424125',
    label: 'Endava',
    price: 100,
    used: true,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '772GsaZX%@!',
  },
  {
    id: '424126',
    label: 'Endava',
    price: 200,
    used: false,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '232GsaZX%@!',
  },
  {
    id: '424127',
    label: 'Endava',
    price: 200,
    used: true,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '992GsaZX%@!',
  },
  {
    id: '424128',
    label: 'Endava',
    price: 100,
    used: false,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '112GsaZX%@!',
  },
  {
    id: '424129',
    label: 'Endava',
    price: 100,
    used: true,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '112GsaZX%@!',
  },
  {
    id: '424130',
    label: 'Endava',
    price: 100,
    used: true,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '112GsaZX%@!',
  },
  {
    id: '424131',
    label: 'Endava',
    price: 100,
    used: true,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '112GsaZX%@!',
  },
  {
    id: '424132',
    label: 'Endava',
    price: 100,
    used: true,
    usedDateTimestamp: new Date().valueOf(),
    generatedTimestamp: new Date().valueOf(),
    user: {
      id: '424125-afc-apsfnle',
      firstName: 'Svetoslav',
      lastName: 'Vizitiu',
      emailName: 'sveat@extasy.com',
      phone: '+40721215252',
      label: 'Sveat',
    },
    ticket: {
      festivalEdition: {
        name: 'untold',
        id: '2456-sdfk-kjri-adlw',
      },
      category: {
        name: 'General Access',
        id: '30di-wifu-mlke-inel',
      },
      ticket: {
        name: '4 Day Access',
        id: 'wiso-wnle-eion-fnej',
      },
    },
    email: 'sveat@extasy.com',
    redeemCode: 'alfa-dei-beta',
    zipPassword: '112GsaZX%@!',
  },
]
export interface RewardTicket {
  ticketType: string
  selectedTicket: string
  dubaiOverwritePriceTypeCode?: string
}

export interface Contact {
  id: string
  firstName: string
  lastName: string
  name: string
  phone: string
  email: string
}

export type VoucherDiscountType = 'PERCENTAGE' | 'AMOUNT'
export type VoucherTypes = 'GENERAL' | 'SINGLE_USER' | 'MULTI_USERS' | 'BATCH'

export const voucherTypes: { name: string; value: VoucherTypes }[] = [
  { name: 'general', value: 'GENERAL' },
  { name: 'Single user', value: 'SINGLE_USER' },
  { name: 'Multi user', value: 'MULTI_USERS' },
  { name: 'All users', value: 'BATCH' },
]
export interface VouchersPayload {
  code?: string
  discountType: VoucherDiscountType
  id?: string
  type?: VoucherTypes
  amount: number
  publishDate?: number | null
  expiryDate?: number | null
  voucherLimit: number | null
  unlimited: boolean
  userLimit: number | null
  userUnlimited: boolean
  festivalId: string | null
  currentUses?: number
  tickets?: IVoucherTickets[]
  users?: IUser[]
  batchId?: string | null
  label?: string
  pngEnabled: boolean
  svgEnabled: boolean
  pdfEnabled: boolean
  csvEnabled: boolean

  published?: boolean
  status?: 'ACTIVE' | 'INACTIVE'
  batchLabel?: string | null
  userTxId?: string
  nrOfVouchers?: number
}

export interface RunaGive {
  phoneNumber: string
  runaToAward: number
  availableDays: number
  availableDate: Date
  unlimited: boolean
}

export interface RunaHistory {
  id: string
  userId: string
  phoneNumber: string
  name: string
  runa: number
  availableDays: number
  availableUntil: Date
  createdBy: string
}
